// List of unique permissions used in the application
export const PERMISSIONS = {

  // Dashboards
  RESOURCE_MAIN_DASHBOARD: 'resource_main_dashboard', // in page use +1
  RESOURCE_INVOICE_METRICS: 'resource_invoice_metrics', // in page use +1
  RESOURCE_BUSINESS_METRICS: 'resource_business_metrics',
  RESOURCE_LEADER_BOARD: 'resource_leader_board',

  // Inbound
  RESOURCE_PURCHASE_ORDERS: 'resource_purchase_orders',
  RESOURCE_FBM_RETURN_ORDERS: 'resource_fbm_return_orders',
  RESOURCE_FBA_REMOVALS: 'resource_fba_removals',
  RESOURCE_ITEM_TRACKING: 'resource_item_tracking', // in page use +1
  RESOURCE_DELIVERED_PACKAGES: 'resource_delivered_packages',
  RESOURCE_PROBLEM_ITEMS: 'resource_problem_items', // in page use +1

  // RESOURCE_INBOUND_ITEM_SORT: 'resource_inbound_item_sort',
  // RESOURCE_INBOUND_ITEM_SORTED_BATCHES: 'resource_inbound_item_sorted_batches',
  // RESOURCE_SORTED_BATCHES_ACCOUNT_MANAGERS: 'resource_sorted_batches_account_managers',

  // Inventory
  RESOURCE_INVENTORY_SNAPSHOT: 'resource_inventory_snapshot',
  RESOURCE_MANAGE_INVENTORY: 'resource_manage_inventory',
  RESOURCE_RECEIVE_INVENTORY: 'resource_receive_inventory',
  RESOURCE_PRODUCT_CATALOG: 'resource_product_catalog',
  RESOURCE_DISPOSITIONS: 'resource_dispositions',

  // Outbound
  RESOURCE_FBA: 'resource_fba',
  RESOURCE_FBM: 'resource_fbm',
  RESOURCE_WFS: 'resource_wfs',
  RESOURCE_MFN: 'resource_mfn', // in page use +1
  RESOURCE_OUTBOUND_SHIPMENTS: 'resource_outbound_shipments',
  RESOURCE_AMAZON_INVENTORY: 'resource_amazon_inventory',

  // Reports
  RESOURCE_REPORTS: 'resource_reports',

  // Tools
  RESOURCE_SHIPPING_LABEL_TOOL: 'resource_shipping_label_tool',
  RESOURCE_FREIGHT_TOOL: 'resource_test', // Now  testing resource
  RESOURCE_BARCODE_PRINT: 'resource_barcode_print',

  // Management
  RESOURCE_CLIENTS: 'resource_clients',
  RESOURCE_SERVICE_CHARGE_PLANS: 'resource_service_charge_plans',
  RESOURCE_TASKS: 'resource_tasks', // in page use +1
  RESOURCE_FILES: 'resource_files',
  RESOURCE_TICKETS: 'resource_admin', // resource_tickets oluşturulacak

  // WMS
  RESOURCE_WMS: 'resource_wms',

  // Account
  RESOURCE_MY_COMPANY: 'resource_my_company',
  RESOURCE_ROLE_MANAGEMENT: 'resource_role_management',
  RESOURCE_PREP_MATERIALS: 'resource_prep_materials',
  RESOURCE_NOTIFICATIONS: 'resource_notifications',
  RESOURCE_COMPANY_CREDENTIALS: 'resource_company_credentials',
  RESOURCE_MY_PLANS: 'resource_my_plans', // in page use +1
  RESOURCE_PRINTER_SETTINGS: 'resource_printer_settings',
  RESOURCE_SUBSCRIPTIONS: 'resource_subscriptions',
  RESOURCE_INVOICE_LIST: 'resource_invoice_list',
  RESOURCE_CUSTOMER_CHARGE: 'resource_customer_charge',
  RESOURCE_INVOICE_PREVIEW: 'resource_invoice_preview',
  RESOURCE_SHIPPING_LABEL_FUNDS: 'resource_shipping_label_funds',
  RESOURCE_MERCHANT_CONNECT: 'resource_merchant_connect',

  // Settings
  RESOURCE_FEE_SETTINGS: 'resource_fee_settings',
  RESOURCE_GENERAL_SETTINGS: 'resource_general_settings',

  // Others
  RESOURCE_COMMON: 'resource_common',
  RESOURCE_HOME: 'resource_home',
  RESOURCE_CHAT: 'resource_chat', // only in 1 place, chat button
  RESOURCE_TEST: 'resource_test', // in page use +1
  RESOURCE_ADMIN: 'resource_admin', // in page use +3
  RESOURCE_PRIVATE_STORE_MANAGEMENT: 'resource_private_store_management', // in page use +1

  // Sayfa içi kullanılanlar

  RESOURCE_CUSTOMER_ACCOUNT_NO: 'resource_customer_account_no', // in page use +75 // // Warehouse kullanıcılarına bakckenden verilecek

  // RESOURCE_CUSTOMER_CHARGE_UPDATE: 'resource_customer_charge_update', // in page use +1 // account no ya bağlanmalı
  // RESOURCE_ACCOUNTING_INVOICE_ADMIN: 'resource_accounting_invoice_admin', // in page use +2 // account no ya bağlanmalı
  // RESOURCE_UPDATE_INVENTORY: 'resource_update_inventory', // in page use +1 // customer haricindekiler görecek
  // RESOURCE_PRODUCT_PRODUCTS_ADMIN: 'resource_product_products_admin', // in page use +1 // account no ya bağlanmalı
  // RESOURCE_CLIENT_USERS: 'resource_client_users', // in router use +3 // account no ya bağlanmalı
}

export const AUDIENCE = {
  WAREHOUSE: 'Warehouse',
  CUSTOMER: 'Customer',
  CUSTOMER_PLUS: 'CustomerPlus',
  CUSTOMER_PLATINUM: 'CustomerPlatinum',
  INDIVIDUAL: 'Individual',
  INDIVIDUAL_PLUS: 'IndividualPlus',
  ALL: 'All',
}

// Burada MENU simule ediliyor. invisible edilenler otomatik olarak ana başlıın seçilmesi halinde verilmektedir. Tek tek verilmemektedir.
export const GROUPED_PERMISSIONS = {
  Dashboards: {
    Dashboard: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_MAIN_DASHBOARD,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.CUSTOMER, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    BusinessMetrics: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_BUSINESS_METRICS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
        // {
        //   key: PERMISSIONS.RESOURCE_INVOICE_METRICS,
        //   audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        // },
      ],
      invisible: false,
    },
    LeaderBoard: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_LEADER_BOARD,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
  },
  Inbound: {
    PurchaseOrders: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_PURCHASE_ORDERS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    DeliveredPackages: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_DELIVERED_PACKAGES,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ProblemItems: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_PROBLEM_ITEMS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ItemStatusTracking: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_ITEM_TRACKING,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
  },
  Inventory: {
    InventorySnapshot: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_INVENTORY_SNAPSHOT,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ManageInventory: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_MANAGE_INVENTORY,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ReceiveInventory: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_RECEIVE_INVENTORY,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ProductCatalog: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_PRODUCT_CATALOG,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    Dispositions: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_DISPOSITIONS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
  },
  Outbound: {
    AmazonFBA: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_FBA,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    AmazonFbaRemovals: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_FBA_REMOVALS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    AmazonInventory: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_AMAZON_INVENTORY,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    AmazonFBM: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_FBM,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    AmazonFbmReturnOrders: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_FBM_RETURN_ORDERS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    WalmartWFS: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_WFS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    MerchantFulfillment: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_MFN,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    // Alt menudeki tüm outbound shipments'ine erişim izni verir.
    OutboundShipments: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_OUTBOUND_SHIPMENTS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
  },
  Reports: {
    ReportingDashboard: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_REPORTS,
          audience: [AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    // Profitability: {
    //   permissions: [],
    //   invisible: true,
    // },
    // AmazonSales: { permissions: [], invisible: true },
    // AmazonReimbursements: { permissions: [], invisible: true },
    // AmazonReturns: { permissions: [], invisible: true },
    // AmazonProfitAndLoss: { permissions: [], invisible: true },
    // AdditionalIncomes: { permissions: [], invisible: true },
    // AdditionalExpenses: { permissions: [], invisible: true },
    // HistoricalInventoryValues: { permissions: [], invisible: true },
  },
  Tools: {
    BuyShippingLabels: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_SHIPPING_LABEL_TOOL,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    // FreightShipments: {
    //   permissions: [
    //     {
    //       key: PERMISSIONS.RESOURCE_FREIGHT_TOOL,
    //       audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
    //     },
    //   ],
    //   invisible: true,
    // },
    Files: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_FILES,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ManualBarcodePrinting: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_BARCODE_PRINT,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    // BarcodeScanning: { permissions: [], invisible: true },
  },
  Management: {
    Clients: {
      permissions: [
        { key: PERMISSIONS.RESOURCE_CLIENTS, audience: [AUDIENCE.WAREHOUSE] },
      ],
      invisible: false,
    },
    ServiceChargePlans: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_SERVICE_CHARGE_PLANS,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
    Tasks: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_TASKS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    // Şu an resource_admin ile belirlendiğinden erişime kapatıldı, özel bir yetki verilerse açılacak.
    // SupportTickets: {
    //   permissions: [
    //     {
    //       key: PERMISSIONS.RESOURCE_TICKETS,
    //       audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
    //     },
    //   ],
    //   invisible: false,
    // },
  },
  WMS: {
    SetupLocations: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_WMS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    // LocationActions: { permissions: [], invisible: true },
    // LabelDesigner: { permissions: [], invisible: true },
  },
  Account: {
    MyCompany: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_MY_COMPANY,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    RoleManagement: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_ROLE_MANAGEMENT,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    PrepMaterials: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_PREP_MATERIALS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    Notifications: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_NOTIFICATIONS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    CompanyCredentials: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_COMPANY_CREDENTIALS,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
    MyPlans: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_MY_PLANS,
          audience: [AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    Invoices: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_INVOICE_LIST,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    InvoicePreviews: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_INVOICE_PREVIEW,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
    Charges: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_CUSTOMER_CHARGE,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.CUSTOMER, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    ShippingLabelFunds: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_SHIPPING_LABEL_FUNDS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    MerchantConnect: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_MERCHANT_CONNECT,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
    PrinterSettings: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_PRINTER_SETTINGS,
          audience: [AUDIENCE.WAREHOUSE, AUDIENCE.INDIVIDUAL, AUDIENCE.INDIVIDUAL_PLUS, AUDIENCE.CUSTOMER_PLUS, AUDIENCE.CUSTOMER_PLATINUM],
        },
      ],
      invisible: false,
    },
    Subscriptions: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_SUBSCRIPTIONS,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
  },
  Settings: {
    General: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_GENERAL_SETTINGS,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
    FeeSettings: {
      permissions: [
        {
          key: PERMISSIONS.RESOURCE_FEE_SETTINGS,
          audience: [AUDIENCE.WAREHOUSE],
        },
      ],
      invisible: false,
    },
  },
}
export const mapPermissionsAndUpdate = (permissionList, permissionSetter) => {
  if (!Array.isArray(permissionList) || !permissionSetter) return

  const traverseGroupedPermissions = obj => {
    Object.keys(obj).forEach(key => {
      const group = obj[key]
      if (group && typeof group === 'object') {
        if (Array.isArray(group.permissions)) {
          group.permissions.forEach(permission => {
            if (permissionList.includes(permission.key)) {
              permissionSetter(permission.key, true)
            }
          })
        }
        traverseGroupedPermissions(group)
      }
    })
  }

  traverseGroupedPermissions(GROUPED_PERMISSIONS)
}

export const createMenuForAudience = audienceType => {
  if (audienceType === AUDIENCE.ALL) {
    return GROUPED_PERMISSIONS
  }

  const filteredMenu = {}

  Object.entries(GROUPED_PERMISSIONS).forEach(([groupName, subGroups]) => {
    const filteredSubGroups = {}

    Object.entries(subGroups).forEach(([subGroup, subGroupData]) => {
      const permissionsArray = subGroupData.permissions
      if (Array.isArray(permissionsArray)) {
        const filteredPermissions = permissionsArray.filter(permission => !permission.audience || permission.audience.includes(audienceType))

        if (filteredPermissions.length > 0) {
          filteredSubGroups[subGroup] = {
            ...subGroupData,
            permissions: filteredPermissions,
          }
        }
      }
    })

    if (Object.keys(filteredSubGroups).length > 0) {
      filteredMenu[groupName] = filteredSubGroups
    }
  })

  return filteredMenu
}
